<template>
  <div v-show="show">
    <!-- 好友邀请开始-->
    <div class="actModules">
      <h3 class="actModules_title" v-text="modulesTitle"></h3>
      <p class="actModules_descripe" v-html="modulesRules"></p>
      <ul class="actInvite_Wrap">
        <!-- TODO: 暂时隐藏,后期使用       <li class="actInvite_list" v-for="(inviteLis,index) in inviteList" :key="index">
          <img :src="inviteLis.img">
        </li>  -->
        <li style="font-size: 18px">已邀请人数：{{ num }}</li>
      </ul>
      <div
        class="actModules_btnWrap"
        v-for="(item, index) in headBtnInfo"
        :key="index"
      >
        <p class="actModules_btnDescript" v-text="item.headBtnDesc"></p>
        <a href="javascript:;" @click="invitation()" class="actModules_btn">{{
          item.headBtnName
        }}</a>
      </div>
      <ul class="actInvite_boxWrap">
        <li
          class="actInvite_boxList"
          v-for="(inviteBag, index) in giftList"
          :key="index"
          v-if="inviteBag.h5Action.value"
        >
          <p class="actInvite_boxTitle" v-text="inviteBag.title"></p>
          <div class="actInvite_boxContent">
            <div class="actInvite_boxImg">
              <img :src="inviteBag.img.value" />
            </div>
            <template>
              <div class="actModules_btnWrap">
                <template v-if="!!h5Geted[index]">
                  <div class="actInvite_boxBtnWrap  disabled">
                    <a href="javascript:;" class="actCharge_boxBtn">{{
                      inviteBag.btnName2
                    }}</a>
                  </div>
                </template>
                <template v-else>
                  <div class="actInvite_boxBtnWrap">
                    <a
                      href="javascript:;"
                      @click="doAction(index)"
                      class="actCharge_boxBtn"
                      >{{ inviteBag.btnName1 }}</a
                    >
                  </div>
                </template>
              </div>
            </template>
          </div>
        </li>
      </ul>
    </div>
    <!-- 好友邀请结束-->
  </div>
</template>

<script>
import './../assets/css/reset.css';
import bus from '../../bus';
import { buryingPoint } from './buryingPoint/inviTation';
import { sharefriend } from './lottery/index';
export default {
	name: 'h5-invite',
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '头部文案',
			bgImg: '背景图片',
			modulesRules: '活动规则',
			headBtnInfo: '头部信息',
			headBtn: '头部按钮',
			headBtnDesc: '功能规则',
			headBtnName: '功能按钮',
			h5Action: 'H5动作',
			giftList: '礼包挡位',
			title: '挡位名称',
			img: '图片',
			btnName1: '功能按钮-领取前',
			btnName2: '功能按钮-领取后',
			invitationCopy: '邀请文案',
			invitationTitle: '邀请文案标题',
			description: '邀请文案内容',
			icon: '邀请文案图片',
			href: '邀请链接',
			queryType: '查询抽奖次数',
			showtype: '展示(1安卓,0 IOS)'
		}
	},
	props: {
		invitationCopy: {
			type: Array,
			default: () => [
				{
					invitationTitle: '',
					description: '',
					icon: '',
					href: ''
				}
			]
		},
		modulesTitle: {
			type: String,
			default: '模块名字'
		},
		modulesRules: {
			type: String,
			default:
        '活动规则：规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案'
		},
		bgImg: {
			type: String,
			default: ''
		},
		headBtnInfo: {
			type: Array,
			default: function () {
				return [
					{
						headBtnDesc: '规则规则规则规则规则规则规则规则规则规则',
						h5Action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '' //
						},
						headBtnName: '功能按钮'
					}
				];
			}
		},
		queryType: {
			type: Array,
			default: () => [
				{
					h5Action: {
						class: 'action',
						type: 'no',
						value: '',
						ruleId: ''
					}
				}
			]
		},
		giftList: {
			type: Array,
			default: function () {
				return [
					{
						title: '自定义邀请人数礼包名称',
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						},
						h5Action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						btnName1: '领取',
						btnName2: '领取成功'
					},
					{
						title: '自定义邀请人数礼包名称',
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						},
						h5Action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						btnName1: '领取',
						btnName2: '领取成功'
					},
					{
						title: '自定义邀请人数礼包名称',
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						},
						h5Action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						btnName1: '领取',
						btnName2: '领取成功'
					},
					{
						title: '自定义邀请人数礼包名称',
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						},
						h5Action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						btnName1: '领取',
						btnName2: '领取成功'
					},
					{
						title: '自定义邀请人数礼包名称',
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						},
						h5Action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						btnName1: '领取',
						btnName2: '领取成功'
					}
				];
			}
		},
		showtype: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			inviteList: [
				{
					img:
            'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_list.png'
				},
				{
					img:
            'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_list.png'
				},
				{
					img:
            'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_list.png'
				},
				{
					img:
            'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_list.png'
				},
				{
					img:
            'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_list.png'
				},
				{
					img:
            'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_list.png'
				},
				{
					img:
            'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_list.png'
				},
				{
					img:
            'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_list.png'
				},
				{
					img:
            'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_list.png'
				},
				{
					img:
            'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_list.png'
				}
			],
			geted: [false, false, false],
			h5Geted: [false, false, false, false, false],
			moduleid: '0',
			num: '0',
			status: true,
			show: true
		};
	},
	mounted () {
		if (this.$actMode !== 'production') {
			return;
		}
		let staticClass = this.$vnode.data.staticClass;
		this.moduleid = staticClass.replace(/ceiba-comp-/, '');
		this.pvKey = `h5_receive_horizontal_${this.$actConfig.actId}_${
			this.moduleid
		}`;
		bus.$on('giftReceivedStatus', isGetedh5 => {
			if (typeof isGetedh5 === 'undefined') {
				return;
			}
			for (let i = 0; i < this.giftList.length; i++) {
				let idx = this.giftList[i].h5Action.ruleId;
				if (typeof isGetedh5['h' + idx] !== 'undefined') {
					if (isGetedh5['h' + idx][0] > 0 && isGetedh5['h' + idx][1] === '0') {
						this.$set(this.h5Geted, i, true);
					} else {
						this.h5Geted[i] = false;
					}
				} else {
					this.h5Geted[i] = false;
				}
			}
			console.log(this.h5Geted);
		});
		bus.$on('enquiryInvitation', () => {
			this.queryPlayer();
		});
		bus.$on('showtype', val => {
			this.show = val === this.showtype;
		});
	},
	methods: {
		async queryShow () {
			try {
				const [
					{
						h5Action: { type, value }
					}
				] = this.headBtnInfo;
				if (type === 'received') {
					await this.$doAction('ame', value, {
						sServiceType: this.$actConfig.gameCode
					});
					this.status = true;
				}
			} catch (e) {
				this.status = false;
				console.log(e);
				alert(e.sMsg);
			}
		},
		async queryPlayer () {
			try {
				const [
					{
						h5Action: { value }
					}
				] = this.queryType;
				const val = {
					...window.bindInfo,
					sServiceType: this.$actConfig.gameCode
				};
				const {
					res: { sOutValue3 }
				} = await this.$doAction('ame', value, val);
				this.num = sOutValue3 ? sOutValue3.split('|').length : '0';
			} catch (e) {
				console.log(e);
			}
		},
		async invitation () {
			await this.queryShow();
			const [
				{ invitationTitle, description, icon, href }
			] = this.invitationCopy;
			let uin = window.milo.cookie.get('uin');
			let openid =
        window.milo.cookie.get('openid') || (uin ? uin.substr(1) : '');
			if (openid) {
				if (this.status) {
					const data = {
						title: invitationTitle,
						description,
						icon,
						href: `${href}&openidA=${openid}&time=${parseInt(new Date().getTime() / 1000)}`
					};
					sharefriend(data);
				}
			} else {
				alert('请先登录');
			}
		},
		doAction (activeIndex) {
			if (this.$actMode !== 'production') {
				return;
			}
			const itemConf = this.giftList[activeIndex];
			if (itemConf.h5Action.type === 'received') {
				this.receiveGift(
					itemConf.h5Action.type,
					itemConf.h5Action.value,
					activeIndex
				);
			} else if (itemConf.h5Action.type === 'gotoApp') {
				this.$gotoApp(itemConf.h5Action.value);
			} else if (itemConf.h5Action.type === 'link') {
				window.location.href = itemConf.h5Action.value;
			}
		},
		receiveGift (actionType, actionValue, activeIndex) {
			this.$doAction(actionType, actionValue)
				.then(({ sPackageName, iPackageId }) => {
					if (sPackageName) {
						alert(`恭喜你获得了${sPackageName}，请到游戏中查收`);
						this.$set(this.h5Geted, activeIndex, true);
						buryingPoint(this.modulesTitle, this.$axios);
					}
				})
				.catch(e => {
					console.log(e);
					alert(e.sMsg);
				});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//引入 scss 模块组件
@import "./../assets/scss/common";

.actInvite_Wrap {
  font-size: 0;
  text-align: center;
  margin: 0.4rem 0;
}
.actModules_btnDescript {
  font-size: 0.24rem;
  color: #4a4a4a;
  text-align: center;
  max-width: 3.2rem;
  margin: 0 auto 0.1rem;
}

.actInvite_list {
  width: 1.2rem;
  height: 1.2rem;
  overflow: hidden;
  @extend %inline-block;
  @include border-radius();
  margin: 0 0.06rem;

  img {
    width: 100%;
    height: 100%;
  }
}

.actInvite_boxWrap {
  width: 7.3rem;
  margin: 0.9rem auto 0;
}

.actInvite_boxTitle {
  font-size: 0.24rem;
  color: #4a4a4a;
  margin-bottom: 0.1rem;
}

.actInvite_boxContent {
  background: #d8d8d8;
  padding: 0.24rem 0.2rem;
  height: 2.3rem;
}

.actInvite_boxContent {
  @extend %clearfix;
}

.actInvite_boxImg {
  @extend %left;
}

.actInvite_boxImg {
  width: 5.1rem;
  height: 1.8rem;

  img {
    width: 100%;
    height: 100%;
  }
}

.actInvite_boxBtnWrap {
  width: 1.8rem;
  height: 100%;
  @extend %relative;
  @extend %right;
}

.actInvite_boxBtn {
  width: 1.6rem;
  height: 0.6rem;
  line-height: 0.6rem;
  font-size: 0.28rem;
  color: #4a4a4a;
  @extend %block;
  text-align: center;
  background: #e27f7f;
  @extend %absolute;
  left: 50%;
  top: 50%;
  @include translate();
}

.actInvite_boxList {
  width: 100%;

  & + .actInvite_boxList {
    margin-top: 0.66rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/x-invite.vue